import { render, staticRenderFns } from "./TgCollapse.vue?vue&type=template&id=1f45125e"
import script from "./TgCollapse.vue?vue&type=script&lang=js"
export * from "./TgCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports